export default {
  common: {
    clearAll: 'Очистить всё',
    restart: 'Перезапустить'
  },
  download: {
    bodyText: 'Нажмите на ссылку ниже, чтобы скачать %{products}',
    bothProducts: 'PlayBase и/или Nexus',
    bodyTextFromAcceptInvitation:
      'Процесс займет некоторое время. Тем временем вы можете продолжать использовать Metrica Sports как обычно.',
    bodyTextFromDeclineInvitation:
      'Вы отклонили приглашение! Нажмите на ссылку ниже, чтобы скачать %{products}',
    bodyTextFromTrial:
      'Добро пожаловать в настройку вашего пробного периода! Проверьте вашу зарегистрированную электронную почту для получения ссылки на верификацию (проверьте папку со спамом).',
    bodyTitle: 'Скачать',
    bodyTitleFromAcceptInvitation: 'Мы переключаем твой аккаунт',
    bodyTitleFromDeclineInvitation: 'Приглашение Отклонено',
    bodyTitleFromTrial: 'Регистрация завершена',
    play2: {
      description:
        'Metrica PlayBase — это интуитивно понятный инструмент анализа, разработанный для тренеров-любителей и профессиональных пользователей, малых клубов и независимых аналитиков. Он упрощает процесс оценки производительности, делая его доступным для всех.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    play3: {
      description:
        'Metrica Nexus разработан для аналитиков и тренеров элитного уровня, которые ищут исчерпывающую информацию о производительности. С передовыми инструментами под рукой, вы можете улучшить стратегии команды и добиться успеха.',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    thanks:
      'Спасибо за регистрацию в Metrica Sports! Чтобы начать с вашей пробной версией, загрузите %{products}.'
  },
  error: {
    restart: 'Похоже, вы пытаетесь воспользоваться тем, что мы всё еще разрабатываем...',
    tryAgainMsg:
      'Пожалуйста, попробуйте еще раз, если эта ошибка повторится, обратитесь в службу поддержки Metrica Sports'
  },
  verifyEmail: {
    generateLink: 'Создайте новую ссылку, войдя в Play',
    readyToLogin: 'Вы готовы войти в систему Play',
    successfully: 'Электронная почта успешно подтверждена',
    unsuccessfully: 'Ошибка при верификации электронной почты, недействительный токен'
  }
}
